export const domainStatusEnum = {
  VERIFYING: 0,
  VERIFIED: 1
};
